module.exports = __webpack_public_path__ + "img/example_book_bank.bd364c70.png";